import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageLayout from "@/components/custom/PageLayout";
import CheckInCard from "@/components/custom/CheckInCard";
import CheckInService from "@/services/api/CheckInService";
import { CheckInRecord } from "@/central-atoms/everest-fleet-pwa/responses";
import { BottomNav } from "./BottomNav";
import ErrorSnackbar from "./ErrorSnackbar";
import DriverHomeBg from "@/assets/backgrounds/DriverHomeBg.svg";

interface Props {
    checkInRecords: CheckInRecord[];
    setCheckInError: any;
    checkInError: string[];
    setCheckInRecords: any;
    setCurrentIndex: any;
    currentIndex: number;
}

const DriverCheckInStack: React.FC<Props> = ({ checkInRecords, setCheckInError, checkInError, setCheckInRecords, setCurrentIndex, currentIndex }) => {
    const navigate = useNavigate();

    // Declare odo and soc state unconditionally.
    const [odo, setOdo] = useState(0);
    const [soc, setSoc] = useState(0);
    const [loading, setLoading] = useState(false);

    // Update odo and soc when checkInRecords or currentIndex changes.
    useEffect(() => {
        if (checkInRecords.length > 0) {
            const currentRecord = checkInRecords[currentIndex];
            setOdo(currentRecord.track_props?.final_odometer_reading || 0);
            setSoc(currentRecord.track_props?.final_soc || 0);
        }
    }, [checkInRecords, currentIndex]);

    const handleConfirm = async () => {
        if (!checkInRecords.length) return;
        setLoading(true);

        try {
            await CheckInService.confirmCheckIn({
                token: currentRecord.track_id,
                hub: currentRecord.hub,
                edited_odometer_reading: odo,
                edited_soc: soc,
                et_id: currentRecord.customer_id,
            });

            if (currentIndex < checkInRecords.length - 1) {
                setCurrentIndex((prev: number) => prev + 1);
            } else {
                setCheckInRecords([]);
                setLoading(false);
                navigate("/check-in");
            }
        } 
        catch (err) {
            setCheckInError(["CheckIn Confirmation failed. Please try again."]);
        }
        finally {
            setLoading(false);
        }
    };

    const currentRecord = useMemo(()=> checkInRecords[currentIndex], [checkInRecords, currentIndex]);

    return (
        <PageLayout noPad>
            <div className="flex flex-col items-center justify-center min-h-screen px-2 py-2 relative">
                <div className="absolute w-full top-0 fixed">
                    <img
                        src={DriverHomeBg}
                        alt="Background"
                        className="w-full"
                    />
                </div>
                <CheckInCard
                    odo={odo}
                    soc={soc}
                    setOdo={setOdo}
                    setSoc={setSoc}
                    checkInRecord={currentRecord}
                    onConfirm={handleConfirm}
                    checkInsLeft={checkInRecords?.length - currentIndex}
                    loading={loading}
                />
                <p className="text-white mt-4">
                    {currentIndex + 1} of {checkInRecords.length}
                </p>
            </div>
            {
                checkInError?.length > 0 && <ErrorSnackbar message={checkInError[0]} />
            }
            <BottomNav active={2} />
        </PageLayout>
    );
};

export default DriverCheckInStack;
